import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import 'styles/components/notice-empty.scss'

const NoticeEmpty = ({ className, children }) => {
  if (children === null) {
    return null
  }

  return (
    <div className={classnames('notice-empty', className)}>
      <div className="notice-empty-in">{children}</div>
    </div>
  )
}

NoticeEmpty.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
}

NoticeEmpty.defaultProps = {
  className: null,
  children: null
}

export default NoticeEmpty
